import React from 'react';
import EcuMessageGen    from './EcuMessageGen'
import EcuMessageIdPcb  from './EcuMessageIdPcb'
import EcuMessageId     from './EcuMessageId'
import EcuMessageResult from './EcuMessageResult'

export default class EcuComps2 extends React.Component {
  //constructor(props) {    
  //  super(props)    
  //}
  render() {    
    //console.log("ecu_comps", this.props.ecu_comps)
    return (
      <>
        {this.props.ecu_comps.map((item, index) => {
          switch (item.type) {
            case "id":      return <EcuMessageId      key={index} data={item.data} title={item.title} />    
            case "id_pcb":  return <EcuMessageIdPcb   key={index} data={item.data} title={item.title} />    
            case "gen":     return <EcuMessageGen     key={index} data={item.data} title={item.title} />     
            case "_result": return <EcuMessageResult  key={index} data={item.data} />          
            default:        return null; 
          }
        })}
      </>
    )
  }
}
